import { Container, Mask } from './style';
import LoadingSVG from '../../assets/loading.svg';

const LoadingFullScreen = () => {
  return (
    <Mask>
      <Container>
        <img src={LoadingSVG} alt="Loading SVG animado" />
      </Container>
    </Mask>
  );
};

export default LoadingFullScreen;
